import { addModal } from 'weblite-web-modal-viewer'
import { PackageLimitReached } from './package-limit-reached'
import { PackageLimitReachedType } from './types'

const COMPONENT_ID = 'callRoomIsFull'

const showPackageLimitReached = (
  props: Parameters<typeof PackageLimitReached>[0],
) => addModal({ id: COMPONENT_ID, props })

export const showPackageLimitReachedDialog = (type: PackageLimitReachedType) =>
  showPackageLimitReached({
    type,
  })

export default {
  [COMPONENT_ID]: {
    Component: PackageLimitReached,
  },
}
